import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useRef } from "react";
import { CustomAmountViewInput, CustomImageView } from "shared/AllViewInputs";
import CustomOverlay from "shared/CustomOverlay";
import { handleFormatDate } from "utils/commonFunctions";
import CustomAddMaintenanceTable from "views/Tables/CustomAddMaintenanceCostsTable";
import EuroIcon from "assets/images/svg/euroIcon.svg";
const DocumentView = ({ document, docIndex, onEdit }) => {
  const accordianHeader = (document) => {
    return (
      <div className="flex align-items-center justify-content-between w-full ">
        <p className="title w-4">{document?.document_type === "Combined"? document?.document_type : `${document?.document_type} Cost`}</p>
        <p className="title w-4">
          {handleFormatDate(document?.processedDate || new Date())}
        </p>
        {/* {document?.id && ( */}
          <>
            <CustomOverlay className="px-3">
              <ul className="no-style p-0">
                <li
                  className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                  onClick={() => onEdit(document?.id, docIndex)}
                >
                  <i className="pi pi-file-edit text-dark"></i> Edit
                </li>
              </ul>
            </CustomOverlay>
          </>
        {/* )} */}
      </div>
    );
  };

  return (
    <Accordion activeIndex={document.id} className="w-full mt-3">
      <AccordionTab
        headerClassName="accordion-role-list"
        headerTemplate={() => accordianHeader(document)}
      >
        <div className="p-4 w-full border-round-xl grid mt-3">
          <div className="col-6">
            <p className="mb-2">Print Date</p>
            <span className="font-bold">
              {handleFormatDate(document?.print_date)}
            </span>
            <p className="mb-2 mt-4">Date From</p>
            <span className="font-bold">
              {handleFormatDate(document?.date_from)}
            </span>
          </div>
          <div className="col-6">
            <p className="mb-2">Year of Statement</p>
            <span className="font-bold">
              {typeof document?.year_of_statement === "object"
                ? handleFormatDate(document?.year_of_statement, "year")
                : document?.year_of_statement}
            </span>
            <p className="mb-2 mt-4">Date To</p>
            <span className="font-bold">
              {handleFormatDate(document?.date_to)}
            </span>
          </div>
          <p className="col-12 mt-4">
            <span className="font-bold">Uploaded documents</span>{" "}
            <div className="flex mt-3 gap-4 flex-wrap">
              {document?.document_file ? (
                <CustomImageView image={document?.document_file} />
              ) : typeof document?.document === "string" ? (
                <CustomImageView image={document?.document} />
              ) : (
                <CustomImageView src={document?.document} />
              )}
            </div>
          </p>

          {(document?.document_type === "Heating" ||
            document?.document_type === "Combined") && (
            <>
              {document?.document_type === "Combined" && (
                <span className="title col-12">Heating Costs</span>
              )}
              <div className="col-6">
                <p className="">Fixed Cost</p>
                <span className="font-bold">
                  {/* {document?.heating_cost?.fixed_cost} */}
                  <CustomAmountViewInput name="fixed_cost" value={document?.heating_cost?.fixed_cost} icon={EuroIcon} ignoreLabel/>
                </span>
              </div>
              <div className="col-6">
                <p className="">Variable Cost</p>
                <span className="font-bold">
                  {/* {document?.heating_cost?.variable_cost} */}
                  <CustomAmountViewInput name="variable_cost" value={document?.heating_cost?.variable_cost} icon={EuroIcon} ignoreLabel/>

                </span>
              </div>
            </>
          )}
          {(document?.document_type === "Maintenance" ||
            document?.document_type === "Combined") && (
            <CustomAddMaintenanceTable
              action={""}
              id={""}
              title={
                document?.document_type === "Combined" ? "Maintenance Cost" : ""
              }
              allCosts={document?.maintenance_costs}
              setAllFurniture={""}
            />
          )}
        </div>
      </AccordionTab>
    </Accordion>
  );
};

export default DocumentView;
